import React, { useEffect, useState } from "react";
import { DataTableRow } from "../../types/constants.types";
import DataCard from "./DataCard";
import Pagination from "../Pagination";

type CardTableProps = {
	dataSet: DataTableRow[];
	reset: boolean;
};
export default function CardTable({ dataSet, reset }: CardTableProps) {
	const [displaDataSet, setDisplayDataSet] = useState(dataSet);
	const [start, setStart] = useState(0);
	const [end, setEnd] = useState(9);
	const [perPageCount, setPerPageCount] = useState(10);

	useEffect(() => {
		if (reset) {
			setStart(0);
			setEnd(9);
			setPerPageCount(10);
		}
	}, [reset]);

	useEffect(() => {
		setDisplayDataSet(dataSet.slice(start, end));
	}, [dataSet, start, end]);

	const setPerPageDataSet = (start: number, end: number) => {
		setEnd(end);
		setStart(start - 1);
	};
	
	return (
		<div className="flex flex-col w-full gap-4 ">
			<div className="">
				<Pagination
					totalRecords={dataSet.length}
					perPageCount={perPageCount}
					setPerPageDataSet={setPerPageDataSet}
					reset={reset}
				/>
			</div>
			<div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 w-full gap-10">
						{dataSet.map((row, idx) => (
							<DataCard
								key={row.data[0]?.searchTerm || row.id || idx}
								data={row.data}
								onClick={row.onClick}
							/>
						))}
			</div>
		</div>
	);
}
